export enum Feature {
  MeetingIntegration = 'MEETING_INTEGRATION',
  UniversalFeedbackCapture = 'UNIVERSAL_FEEDBACK_CAPTURE',
}
